import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, ArrowRightIcon } from "lucide-react";
import { painPoints } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function PainPoints() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const total = painPoints.items.length;
  const count = selected.size;
  const toggle = (title: string) => setSelected(prev => {
    const next = new Set(prev);
    next.has(title) ? next.delete(title) : next.add(title);
    return next;
  });
  return <section className="bg-card py-9 md:py-16" data-id="element-164" data-mp="1o03kg21d2btp">
      <div className="mx-auto max-w-6xl px-5" data-id="element-165" data-mp="1o1en1yj2ldj8">
        <SectionHeader eyebrow={painPoints.eyebrow} title={painPoints.title} tone="coral" data-id="element-166" data-mp="1sy52cjn1w53l" />
        <p className="mt-3 text-sm font-semibold text-coral" data-id="element-167" data-mp="3id336411fm57">{painPoints.prompt}</p>

        <ul className="mt-3 grid grid-cols-2 gap-2 md:mt-6 md:grid-cols-4 md:gap-4" data-id="element-168" data-mp="3ncnze6otpge8">
          {painPoints.items.map(p => {
          const isOn = selected.has(p.title);
          return <li key={p.title} data-id="element-169" data-mp="1u1lora5upt9w">
                <button type="button" onClick={() => toggle(p.title)} aria-pressed={isOn} className={`flex h-full w-full flex-col rounded-xl p-3 text-left ring-1 transition-[background-color,box-shadow,transform] duration-150 ease-out active:scale-[0.97] md:p-4 ${isOn ? "bg-coral-soft ring-2 ring-coral" : "bg-paper ring-line hover:ring-coral/40"}`} data-id="element-170" data-mp="1u0ix300pfmsx">
                  <span className="flex items-start justify-between gap-2" data-id="element-171" data-mp="1p30ml571gzit">
                    <span className="text-[13px] font-bold leading-snug md:text-base" data-id="element-172" data-mp="1k3e8ktjdzf8y">{p.title}</span>
                    <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOn ? "border-coral bg-coral text-white" : "border-line bg-card"}`} aria-hidden="true" data-id="element-173" data-mp="30hnulh05orwm">
                      {isOn && <CheckIcon className="h-3 w-3" data-id="element-174" data-mp="1y2ewned0urfk" />}
                    </span>
                  </span>
                  <span className="mt-1 hidden text-sm leading-relaxed text-muted md:block" data-id="element-175" data-mp="226mldbjhc7ds">{p.text}</span>
                </button>
              </li>;
        })}
        </ul>

        <div className="mt-4 rounded-xl bg-chalk p-4 text-white md:mt-8 md:p-5" data-id="element-176" data-mp="1ag8i0993edgd">
          <div className="flex items-center justify-between gap-3 text-sm" data-id="element-177" data-mp="1ehaeiibmkben">
            <span className="font-semibold" data-id="element-178" data-mp="1jettxlk26u86">Te pasan {count} de {total}</span>
            <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/15" data-id="element-179" data-mp="1o625oo8v2roi">
              <motion.span className="block h-full rounded-full bg-pencil" animate={{
              width: `${count / total * 100}%`
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-180" data-mp="1o7wrs5vvcpu6" />
            </span>
          </div>
          <AnimatePresence mode="wait" initial={false} data-id="element-181" data-mp="o5gtekfjwo90">
            <motion.div key={count === 0 ? "none" : count < 4 ? "few" : "many"} initial={{
            opacity: 0,
            y: 4
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -4
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="mt-2 flex flex-wrap items-center justify-between gap-2" data-id="element-182" data-mp="j6vssjwe02k1">
              <p className="font-display text-lg font-bold md:text-2xl" data-id="element-183" data-mp="g5ocqr647p2">
                {count === 0 ? painPoints.closing : count < 4 ? painPoints.resultFew : painPoints.resultMany}
              </p>
              {count > 0 && <a href="#tomos" className="inline-flex items-center gap-1 text-sm font-bold text-pencil" data-id="element-184" data-mp="3mpgpktpx91xq">
                  {painPoints.resultCta}
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-185" data-mp="3dnfti06fclxn" />
                </a>}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}